module.exports = __webpack_public_path__ + "static/media/1-min.029a1550.jpg";